import { useCatalogoStore } from '@/features/catalogo/store/store';
import { useLoginAdminStore } from '@/features/login-admin/store';
import { isTokenAdminValid } from '@/features/login-admin/util';
import { resetLoginStore } from '@/features/login/store';
import { isTokenValid } from '@/features/login/util/token';
import { router } from '@/router/Router';
import type { RouteType } from './util';

export function getToken(routeType: RouteType): string {
    if (import.meta.env.MODE === 'test' || import.meta.env.VITEST) {
        return '';
    }

    // Precisa checar se é admin primeiro
    // baseado na url já que qualquer requisição deve usar o token do admin se estiver logado como admin
    if (routeType === 'admin') {
        return adminToken();
    } else if (routeType === 'catalogo') {
        return catalogoToken();
    } else {
        return userToken();
    }
}

export function adminTokenInvalid(): never {
    useLoginAdminStore.getState().clearLogin();
    void router.navigate({ to: '/admin/auth/login' });
    throw new Error('Token inválido');
}

function adminToken(): string {
    const { valid, token } = isTokenAdminValid();
    return valid ? `Bearer ${token}` : adminTokenInvalid();
}

export function catalogoTokenInvalid(): never {
    throw new Error('Token inválido');
}

function catalogoToken(): string {
    const { status, token } = useCatalogoStore.getState().getTokenStatus();
    return token && status !== 'expired' ? `Bearer ${token}` : catalogoTokenInvalid();
}

export function userTokenInvalid(): never {
    resetLoginStore();
    void router.navigate({ to: '/auth/login' });
    throw new Error('Token inválido');
}

function userToken(): string {
    const { valid, token } = isTokenValid();
    return valid ? `Bearer ${token}` : userTokenInvalid();
}
